import { Middleware } from 'redux';
import { dispatch } from 'store';
import { hasError } from './slices/security';

const errorHandlingMiddleware: Middleware = (store) => (next) => (action) => {
    if (action.type === 'menu/activeItem') {
        dispatch(hasError(null));
    }

    if (action.type.endsWith('rejected' && action.type !== 'product/saveApprovalStatus/pending')) {
        dispatch(hasError(action.error));
    }

    return next(action);
};

export default errorHandlingMiddleware;
